export function Disable(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99987 0.533203C3.87614 0.533203 0.533203 3.87614 0.533203 7.99987C0.533203 12.1236 3.87614 15.4665 7.99987 15.4665C12.1236 15.4665 15.4665 12.1236 15.4665 7.99987C15.4665 3.87614 12.1236 0.533203 7.99987 0.533203ZM7.99987 2.1332C11.2399 2.1332 13.8665 4.7598 13.8665 7.99987C13.8665 9.33145 13.4229 10.5594 12.6754 11.544L4.45572 3.32435C5.44033 2.57683 6.66829 2.1332 7.99987 2.1332ZM11.544 12.6754L3.32435 4.45572C2.57683 5.44033 2.1332 6.66829 2.1332 7.99987C2.1332 11.2399 4.7598 13.8665 7.99987 13.8665C9.33145 13.8665 10.5594 13.4229 11.544 12.6754Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
